import {getPolishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Ohodnoťte článok',
    message: 'Odovzdané hlasy',
    votes: votes => `${getPolishPlurals(["názor", "názory", "názory"], +votes)},`,
    score: 'hodnotenie',
  },
  feedback: {
    label: 'Je tento článok užitočný?'
  }
};
